import {
  GroupWithMetadata,
  AssociationDtoWithMetadata
} from 'legacy/groups/types';

export interface ScreeningQuestionsConfig {
  shouldShowScreeningQuestions: boolean;
  screeningQuestionsFormId?: string;
}

/**
 * Determines screening questions configuration based on organization and association data.
 *
 * Priority logic:
 * 1. If organization has screening questions enabled and form ID, use organization's form
 * 2. Otherwise, if organization doesn't have a form ID and association has screening
 *    questions enabled with form ID, use association's form
 * 3. Default to no screening questions required
 */
export function getScreeningQuestionsConfig(
  organization?: GroupWithMetadata,
  association?: AssociationDtoWithMetadata
): ScreeningQuestionsConfig {
  let shouldShowScreeningQuestions = false;
  let screeningQuestionsFormId: string | undefined;

  if (
    organization?.requestScreeningQuestions === true &&
    organization?.screeningQuestionsFormId
  ) {
    shouldShowScreeningQuestions = true;
    screeningQuestionsFormId = organization.screeningQuestionsFormId;
  } else if (!organization?.screeningQuestionsFormId) {
    if (
      association?.requestScreeningQuestions === true &&
      association?.screeningQuestionsFormId
    ) {
      shouldShowScreeningQuestions = true;
      screeningQuestionsFormId = association.screeningQuestionsFormId;
    }
  }

  return {
    shouldShowScreeningQuestions,
    screeningQuestionsFormId
  };
}
